import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import LabRequest from "./labRequest"
import "../../Patient/list.scss"

const LabRequestContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
           <LabRequest />
        </>
      </div>
    </div>
  )
}

export default LabRequestContainer